import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	inject,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LeapOnboardingDialogData } from '../../entry-point/entry-point.types';
import { LeapOnboardingStatus } from '../../leap-api.service';
import { ICON } from '@core/util/icon';
import { NavigationService } from '@services/nav/nav.service';
import { ICON_STYLE } from '@core/util/icon';
import {
	ILeapOnboardingService,
	LEAP_ONBOARDING_SERVICE,
} from '../../leap-onboarding.models';
import { BillingService } from '@services/billing/billing.service';
import { MatterFileType, MatterSource } from '@models/matter';

@Component({
	selector: 'app-leap-welcome',
	templateUrl: './welcome.component.html',
	styleUrls: ['./welcome.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class LeapWelcomeComponent implements OnInit {
	protected salePrice = 0;
	protected purchasePrice = 0;
	protected refinancePrice = 0;
	protected loading = true;

	public leapOnboardingStatus: LeapOnboardingStatus;
	public ICON = ICON;
	public ICON_STYLE = ICON_STYLE;
	private onboardingService: ILeapOnboardingService = inject(
		LEAP_ONBOARDING_SERVICE,
	);

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: LeapOnboardingDialogData,
		private navService: NavigationService,
		private billingService: BillingService,
		private changeDetectorRef: ChangeDetectorRef,
	) {}

	async ngOnInit(): Promise<void> {
		this.leapOnboardingStatus =
			this.data.onboardingStatusResponse.leapOnboardingStatus;

		const salePricePromise = this.billingService.getPrice(
			MatterFileType.SALE,
			MatterSource.LEAP,
		);
		const purchasePricePromise = this.billingService.getPrice(
			MatterFileType.PURCHASE,
			MatterSource.LEAP,
		);
		const refinancePricePromise = this.billingService.getPrice(
			MatterFileType.REFINANCE,
			MatterSource.LEAP,
		);

		const [salePriceResult, purchasePriceResult, refinancePriceResult] =
			await Promise.all([
				salePricePromise,
				purchasePricePromise,
				refinancePricePromise,
			]);
		this.salePrice = salePriceResult;
		this.purchasePrice = purchasePriceResult;
		this.refinancePrice = refinancePriceResult;

		this.loading = false;
		this.changeDetectorRef.detectChanges();
	}

	async handleConnectToCloserClick() {
		// const sdk = await this.leapSdkService.GetLeapSDK();
		// const { hostInfo } = sdk.leapContext;
		//
		// if (!hostInfo?.hostVersion) {
		// 	this.onboardingService.goToUpdateLeapReminderScreen();
		// 	Logger.error('[Leap onboarding-flow] FAILED TO GET HOST VERSION INFO');
		// 	return;
		// }
		//
		// if (isNewerVersion(hostInfo.hostVersion, this.minimumLeapVersion)) {
		// 	Logger.info(
		// 		`[Leap onboarding-flow] USER HAS A SUPPORTED VERSION: Current: ${hostInfo.hostVersion}, Minimum: ${this.minimumLeapVersion}`,
		// 	);
		this.onboardingService.goToLoginScreen();
		// } else {
		// 	Logger.error(
		// 		`[Leap onboarding-flow] USER HAS AN UNSUPPORTED VERSION: Current: ${hostInfo.hostVersion}, Minimum: ${this.minimumLeapVersion}`,
		// 	);
		// 	this.onboardingService.goToUpdateLeapReminderScreen();
		// }
	}

	goToLawlabsWebsite(event: Event) {
		event.preventDefault();
		this.navService.goToRemoteUrl('https://www.lawlabs.ca/', true);
	}
}
